// externals
import React from 'react';

// components
import { Button } from '@interstate/components/Button';

import CreditSourceHeader from './CreditSourceHeader';

// styles
import { StyledCard, StyledCardHeader, StyledBodyText } from './AltSoftPullConsentAlert.style';

export interface AltSoftPullConsentAlertProps {
    onAccept: () => void;
}

const ALERT_BODY =
    "Click initiate soft pull. This will obtain the customer's credit information solely for " +
    'evaluating financing and deal structure options, which will be presented through AI-powered personalized insights. ' +
    "This inquiry will not affect the customer's credit score.";

const prefix = 'alt-soft-pull-consent-alert';

const AltSoftPullConsentAlert: React.FC<AltSoftPullConsentAlertProps> = ({ onAccept }) => {
    return (
        <StyledCard data-testid={prefix}>
            <StyledCardHeader>
                <CreditSourceHeader />
                <Button
                    id={`${prefix}-initiate-button`}
                    data-testid={`${prefix}-initiate-button`}
                    buttonStyle="secondary"
                    size="sm"
                    onClick={onAccept}
                >
                    Initiate Soft Pull
                </Button>
            </StyledCardHeader>
            <StyledBodyText data-testid={`${prefix}-body`} variant="body-sm" tag="div">
                {ALERT_BODY}
            </StyledBodyText>
        </StyledCard>
    );
};

export default AltSoftPullConsentAlert;
